import axios from "axios";
import { EMPLOYEE_DASHBOARD_API_URL } from "../../api_helper";

axios.interceptors.request.use((req) => {
    if (localStorage.getItem("access")) {
        req.headers.Authorization = `Bearer ${JSON.parse(localStorage.getItem("access")).access_token}`;
    }
    return req;
});

axios.defaults.headers.common["Accept"] = "application/json";
axios.defaults.headers.common["Content-Type"] = "application/json";

// Send otp to Initiate Complete KYC Reg Form 
export const add_truck_api = (formData) =>
  axios.post(EMPLOYEE_DASHBOARD_API_URL + "trucks/add_truck", formData, { withCredentials: false });
